// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2218 ? "4b279159" : chunkId) + "." + {"2218":"86b6c6060eb1784d","4655":"f3ead92be9b127b4","6964":"0fc4ef6abc705e29"}[chunkId] + ".js";
};